export function bedrockGeoPrefix(region: string): string | null {
  if (region.startsWith("us-gov-")) return "us-gov";
  if (region.startsWith("us-") || region.startsWith("ca-")) return "us";
  if (region.startsWith("eu-")) return "eu";
  // Current Claude models get au./jp./global. profiles in ap- regions, never
  // apac. — that prefix only exists for legacy models.
  if (region === "ap-northeast-1" || region === "ap-northeast-3") return "jp";
  if (region === "ap-southeast-2" || region === "ap-southeast-4") return "au";
  return null;
}
